// G-C5: literales en euskera (default) y castellano.
export type Lang = 'eu' | 'es'

const DICT = {
  temporada: { eu: 'Denboraldia', es: 'Temporada' },
  cargando: { eu: 'Kargatzen...', es: 'Cargando...' },
  plantilla: { eu: 'Plantilla', es: 'Plantilla' },
  sinAcceso: { eu: 'Sarbiderik ez', es: 'Sin acceso' },
  sinAccesoMensaje: {
    eu: 'Ez duzu talde honetarako sarbiderik.',
    es: 'No tienes acceso a este equipo.',
  },
  sinCuentaMensaje: {
    eu: 'Auth0-n saioa hasi duzu baina ez dago zure konturako erabiltzailerik aplikazio honetan. Beste kontu batekin saioa hasi baduzu, itxi saioa eta saiatu berriro.',
    es: 'Has iniciado sesión, pero tu cuenta no tiene usuario en esta aplicación. Si has entrado con otra cuenta, cierra sesión y vuelve a intentarlo.',
  },
  salir: { eu: 'Irten', es: 'Salir' },
  backoffice: { eu: 'Kudeaketa', es: 'Backoffice' },
  // Título de la lista de categorías del menú lateral (look & feel, 2026-10-23).
  misEquipos: { eu: 'Nire taldeak', es: 'Mis equipos' },
  conFicha: { eu: 'Fitxadunak', es: 'Con ficha' },
  sinFicha: { eu: 'Fitxarik gabekoak', es: 'Sin ficha' },
  entrenadores: { eu: 'Entrenatzaileak', es: 'Entrenadores' },
  // Issue #80: delegados en la plantilla.
  delegados: { eu: 'Ordezkariak', es: 'Delegados' },
  // Issue #76: Excel de la plantilla del equipo.
  excelEquipo: { eu: '⬇ Taldearen Excela', es: '⬇ Excel del equipo' },
  miembrosActivos: { eu: 'kide aktibo', es: 'miembros activos' },
  // Issue #79: ayuda del arrastrar y soltar (solo admin).
  arrastrarParaOrdenar: { eu: 'Arrastatu ordenatzeko', es: 'Arrastra para ordenar' },
  asistenciaMedia: { eu: 'Batez besteko asistentzia', es: 'Asistencia media' },
  fechaIncorporacion: { eu: 'Sarrera data', es: 'Fecha de incorporación' },
  sinEquipos: { eu: 'Ez dago talderik kategoria honetan', es: 'No hay equipos en esta categoría' },
  volver: { eu: 'Atzera', es: 'Volver' },
  // Petición del club (2026-10-31): manual de usuario dentro de la app (`ayuda/ManualPage`).
  ayuda: { eu: 'Laguntza', es: 'Ayuda' },
  manualTitulo: { eu: 'Erabiltzailearen eskuliburua', es: 'Manual de usuario' },
  manualIntro: {
    eu: 'Zure rolarekin erabil dezakezunaren gida. Sakatu atal bat zabaltzeko.',
    es: 'Guía de lo que puedes hacer con tu rol. Pulsa una sección para desplegarla.',
  },
  buscarManual: { eu: 'Bilatu eskuliburuan', es: 'Buscar en el manual' },
  manualSinResultados: { eu: 'Ez da ezer aurkitu', es: 'No se ha encontrado nada' },
  seleccionaTemporada: { eu: 'Aukeratu denboraldia', es: 'Selecciona temporada' },
  cerrada: { eu: 'itxita', es: 'cerrada' },
  temporadaCerradaBanner: {
    eu: 'Denboraldia itxita — irakurketa soilik',
    es: 'Temporada cerrada — solo lectura',
  },
} as const

export type DictKey = keyof typeof DICT


export function t(key: DictKey, lang: Lang): string {
  return DICT[key][lang]
}
